import { ClipboardEvent } from 'react';

export const preventPasting = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
};
